import { render, staticRenderFns } from "./ProTemplate.vue?vue&type=template&id=51d1c848&scoped=true"
import script from "./ProTemplate.vue?vue&type=script&lang=js"
export * from "./ProTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1c848",
  null
  
)

export default component.exports